export const images = {
  stack: 'https://cdn.magicpatterns.com/uploads/7i1NLPjZYYYnVYphi2xp9f/pasted-image.png',
  spread: 'https://cdn.magicpatterns.com/uploads/qSwqoreDLPYqHaW7kwZCRo/pasted-image.png',
  cover: 'https://cdn.magicpatterns.com/uploads/9phQNuwsCzos7uBFboCvrK/pasted-image.png',
};

export const price = { total: '123$', today: '14.99$' };

export const checkoutUrl = 'https://diario-deprioridades.impultienda.ar/checkout';

// Pega aquí el enlace de tu video (YouTube embed, Vimeo, etc.)
export const helpVideoUrl = '';

export const painPoints = [
  {
    lead: 'Llegas al final del día agotada',
    rest: 'y sientes que hiciste de todo… menos lo que realmente importaba. Las tareas de todos estaban hechas. Las tuyas, otra vez para mañana.',
  },
  {
    lead: 'Tienes mil cosas en la cabeza',
    rest: 'y no sabes por dónde empezar. Esa sensación de que todo es urgente y tú eres la última de la lista.',
  },
  {
    lead: 'Has intentado organizarte con apps, libretas, listas…',
    rest: 'y a los tres días lo abandonas porque se siente como una obligación más.',
  },
  {
    lead: 'Llevas meses diciéndote "cuando tenga tiempo me cuido más".',
    rest: 'Pero ese momento nunca llega porque nadie te lo va a dar. Tienes que tomártelo.',
  },
  {
    lead: 'Sabes lo que quieres lograr,',
    rest: 'pero el día se va y tú sigues en el mismo lugar. Sin avanzar. Sin sentirte tú.',
  },
];

export const benefits = [
  {
    icon: 'heart',
    title: 'Aprenderás a priorizarte sin sentir culpa',
    text: 'Porque no se trata de hacer más. Se trata de darte el lugar que mereces en tu propia vida. Y eso empieza aquí.',
  },
  {
    icon: 'brain',
    title: 'Ya no andarás con mil pensamientos a la vez',
    text: 'Escribir te va a ordenar por dentro. Como una conversación contigo misma que finalmente trae claridad, paz y dirección.',
  },
  {
    icon: 'calendar',
    title: 'Tendrás un espacio sagrado para planear, reflexionar y revisar tu semana',
    text: 'Sin complicaciones ni exigencias imposibles. Un ritual tuyo, para ti, que funciona de verdad.',
  },
  {
    icon: 'sparkles',
    title: 'Empezarás a hacer más cosas que de verdad te gustan',
    text: 'Conectarás con lo que te nutre, con lo que te hace sentir viva. Porque eso también cuenta. Y mucho.',
  },
] as const;

export const bonuses = [
  {
    number: 1,
    title: 'Libro de 100 citas para hacer sola',
    value: '15$',
    text: 'Para los momentos en que necesitas un empujón tuyo, para ti.',
  },
  {
    number: 2,
    title: 'Plantilla Tu Semana Ideal',
    value: '9$',
    text: 'Diseña la semana que quieres vivir, no la que simplemente te pasa. Espacios para ti, para tus metas y para lo que te nutre.',
  },
  {
    number: 3,
    title: 'Plantilla Lista de Hábitos',
    value: '17$',
    text: 'Organiza los hábitos que quieres construir en un solo lugar. Frecuencia, seguimiento y progreso, para que no se quede en intención y pase a la acción real.',
  },
  {
    number: 4,
    title: 'Plantilla Prioridades del Día',
    value: '15$',
    text: 'Empieza cada mañana sabiendo qué es lo más importante, para que nunca vuelvas a llegar al final del día sin haber avanzado en lo que de verdad importa.',
  },
  {
    number: 5,
    title: 'Plantilla Mapa de Sueños y Metas',
    value: '17$',
    text: 'Saca de tu cabeza todo lo que quieres lograr y ponlo en papel. Un mapa visual para que tus metas dejen de ser sueños y se conviertan en un plan real.',
  },
];

export const inclusions = [
  'Lista de afirmaciones positivas',
  'Carta para mi yo del futuro',
  'Plantilla de hábitos que te sabotean',
  'Vision board',
  'Plantilla para conocer quién realmente soy',
  'Plantilla de metas para amarme más',
  'Plantilla de progreso del mes',
  'Plantillas semanales y muchas más',
  'Actividades reflexivas',
  '30 desafíos para priorizarte',
  'Check-in semanal',
  'Frases motivacionales',
];

export const valueStack = [
  { item: 'Diario de Prioridad completo en PDF', value: '$65' },
  { item: 'Plantilla Prioridades del Día PDF', value: '$15' },
  { item: 'Plantilla Lista de Hábitos PDF', value: '$17' },
  { item: 'Plantilla Tu Semana Ideal PDF', value: '$9' },
  { item: 'Plantilla Mapa de Sueños y Metas PDF', value: '$17' },
  { item: 'Libro de 100 citas PDF', value: 'Invaluable' },
];

export const testimonials = [
  {
    name: 'Laura M.',
    quote:
      'Por primera vez en años termino el día sintiendo que hice algo por mí. Los desafíos diarios son cortitos y se sienten posibles.',
  },
  {
    name: 'Daniela R.',
    quote:
      'Lo imprimí y lo tengo en mi mesa de noche. El check-in semanal me cambió la forma de ver mis domingos.',
  },
  {
    name: 'Camila V.',
    quote:
      'Probé mil apps y ninguna me duró. Esto es distinto: escribir me ordena la cabeza y ya no vivo apagando incendios.',
  },
];

export const faqs = [
  {
    q: '¿Cómo recibo mi diario?',
    a: 'Inmediatamente después de tu compra recibirás un correo con el enlace de descarga del diario y los 5 bonos. Sin esperas.',
  },
  {
    q: '¿Es difícil de usar?',
    a: 'Para nada. Cada página te guía paso a paso. Solo necesitas unos minutos al día y ganas de darte tu lugar.',
  },
  {
    q: '¿Es un producto físico?',
    a: 'No. Es un producto digital en PDF, así que no pagas envío y lo tienes al instante, estés donde estés.',
  },
  {
    q: '¿En cuánto tiempo veo resultados?',
    a: 'Muchas personas sienten más claridad desde la primera semana. El método está diseñado para que en 30 días priorizarte se vuelva un hábito.',
  },
  {
    q: '¿Puedo imprimirlo?',
    a: 'Sí. Son más de 160 páginas imprimibles. Puedes imprimirlo completo, solo las plantillas que necesites, o usarlo en tu tablet.',
  },
];

export const recentPurchases = [
  { name: 'María', place: 'España', ago: 'hace 1 minuto' },
  { name: 'Valentina', place: 'México', ago: 'hace 3 minutos' },
  { name: 'Sofía', place: 'Colombia', ago: 'hace 5 minutos' },
  { name: 'Lucía', place: 'Argentina', ago: 'hace 8 minutos' },
  { name: 'Andrea', place: 'Chile', ago: 'hace 11 minutos' },
  { name: 'Paula', place: 'Perú', ago: 'hace 14 minutos' },
];
